import React from 'react';
import ShareGauge from './ShareGauge';

const MetricCell = ({ value, label, color, loading }) => (
  <div className="dg-sector-metric-pair">
    <div className="dg-sector-metric-value" style={color ? { color } : undefined}>
      {loading ? '—' : value}
    </div>
    <div className="dg-sector-metric-label">{label}</div>
  </div>
);

// Setor (Funilaria/Estética): linha de cima (nome + métricas + share no faturamento;
// cada métrica pode agrupar um par via `stack`), linha de baixo (insumos + custos, quando houver).
const SegmentSection = ({
  title, subtitle, color, iconGradient, icon, expenseIcon, metrics = [], insumos, costs = [], share, loading,
}) => (
  <section className="dg-card dg-sector">
    <div className="dg-sector-top">
      <div className="dg-sector-name">
        <span className="dg-sector-icon" style={{ background: iconGradient }}>{icon}</span>
        <div>
          <div className="dg-sector-title">
            <span className="dg-sector-dot" style={{ background: color }} />
            {title}
          </div>
          <div className="dg-sector-subtitle">{subtitle}</div>
        </div>
      </div>

      {metrics.map((m) => {
        const cells = m.stack || [m];
        const groupClass = m.stack ? 'dg-sector-metric dg-sector-metric--stack' : 'dg-sector-metric';
        return (
          <div className={groupClass} key={cells[0].label}>
            {cells.map((c) => (
              <MetricCell key={c.label} {...c} loading={loading} />
            ))}
          </div>
        );
      })}

      <div className="dg-sector-metric dg-sector-metric--share">
        <ShareGauge percent={share.percent} color={color} loading={loading} label="Share" size={58} />
        <div className="dg-sector-metric-label">Share no faturamento total</div>
        <div className="dg-share-value">{share.sub}</div>
      </div>
    </div>

    <div className={costs.length > 0 ? `dg-sector-bottom dg-sector-bottom--with-costs dg-sector-bottom--costs-${costs.length}` : 'dg-sector-bottom'}>
      <div className="dg-expense-info">
        <span className="dg-expense-icon">{expenseIcon}</span>
        <div className="dg-expense-body">
          <div className="dg-expense-label">{insumos.label}</div>
          <div className="dg-expense-value">{loading ? '—' : insumos.value}</div>
        </div>
        {costs.length === 0 && (
          <div className="dg-expense-gauge">
            <ShareGauge percent={insumos.percentValue} color={color} loading={loading} label="Insumos" size={58} />
            <span className="dg-expense-gauge-cap">{insumos.percentCaption}</span>
          </div>
        )}
      </div>

      {costs.map((c) => (
        <div className="dg-cost-cell" key={c.label}>
          <div className="dg-cost-value" style={c.color ? { color: c.color } : undefined}>
            {loading ? '—' : c.value}
          </div>
          <div className="dg-cost-label">{c.label}</div>
        </div>
      ))}

      {costs.length > 0 && (
        <div className="dg-expense-gauge">
          <ShareGauge percent={insumos.percentValue} color={color} loading={loading} label="Insumos" size={58} />
          <span className="dg-expense-gauge-cap">{insumos.percentCaption}</span>
        </div>
      )}
    </div>
  </section>
);

export default SegmentSection;
